import { useAppDispatch } from '@/hook';
import { setOneMedicalMonthlyYearlyDeductible } from '@/reducers/feature-flags';
import { OneMedicalMonthlyYearlyDeductibleFlag } from '@/utility/featureFlags/config';
import { useBooleanFlagValue } from '@openfeature/react-sdk';
import { useEffect } from 'react';

// Reads the Datadog (OpenFeature) deductible flag and syncs it into redux.
export const useOneMedicalMonthlyYearlyDeductible = () => {
  const dispatch = useAppDispatch();
  const isEnabled = useBooleanFlagValue(
    OneMedicalMonthlyYearlyDeductibleFlag.key,
    false,
  );

  useEffect(() => {
    dispatch(setOneMedicalMonthlyYearlyDeductible(isEnabled));
  }, [isEnabled, dispatch]);

  return isEnabled;
};
